var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 3.00012C3.6268 3.00012 3 3.62692 3 4.40012V18.8001C3 19.5733 3.6268 20.2001 4.4 20.2001H18.8C19.5732 20.2001 20.2 19.5733 20.2 18.8001V4.40012C20.2 3.62692 19.5732 3.00012 18.8 3.00012H4.4ZM1 4.40012C1 2.52235 2.52223 1.00012 4.4 1.00012H18.8C20.6778 1.00012 22.2 2.52235 22.2 4.40012V18.8001C22.2 20.6779 20.6778 22.2001 18.8 22.2001H4.4C2.52223 22.2001 1 20.6779 1 18.8001V4.40012ZM18.0077 8.49321C18.3982 8.88373 18.3982 9.5169 18.0077 9.90742L14.4077 13.5074C14.0172 13.8979 13.384 13.8979 12.9935 13.5074L10.7006 11.2145L7.20769 14.7074C6.81717 15.0979 6.184 15.0979 5.79348 14.7074C5.40295 14.3169 5.40295 13.6837 5.79348 13.2932L9.99348 9.09321C10.384 8.70269 11.0172 8.70269 11.4077 9.09321L13.7006 11.3861L16.5935 8.49321C16.984 8.10269 17.6172 8.10269 18.0077 8.49321Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.2786e213ed6d3dc57f445672a3a390e3.svg";
export { ForwardRef as ReactComponent };